import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { AuthService } from "@shared/auth/auth.service";
import { Observable } from "rxjs";
import { Constants } from "@constants";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let reqNuevo = req;

        if (this.authService.token) {
            if (req.url.startsWith(Constants.apiURL)) {
                reqNuevo = req.clone({
                    headers: req.headers.set("Authorization", `Bearer ${this.authService.token}`)
                });
            }
        }

        return next.handle(reqNuevo);
    }
}
